export enum ContentType {
  ProductPackage = 'product_package',
  ProductHeader = 'product_header',
  ProductContainer = 'product_container',
  ProductArticle = 'product_article',
  ProductPart = 'product_part',
  Product = 'product',
  SectionExpanded = 'section_expanded',
  SectionStandalone = 'section_standalone',
  SectionBox = 'section_box',
  Folder = 'folder',
  File = 'file',
  UploadedFile = 'upload_file',
  Link = 'link',
  LearningPath = 'learning_path',
  Video = 'video',
  BlogPost = 'blog_post',
  BookReader = 'book_reader',
  Author = 'author',
  Presentation = 'presentation',
  ThreeStepPage = 'page_three_step',
  GridPage = 'page_grid',
  SideBySidePage = 'page_side_by_side',
  VideoPage = 'page_video',
  ArticlePage = 'page_article',
  TextAndImage = 'content_text_and_image',
  Image = 'image',
  ImageCollection = 'image_collection',
  Svg = 'svg',
  FlytTask = 'flyt_task',
  ImageAndMaybeText = 'page_image_and_maybe_text',
  OnlyTextPage = 'page_only_text_no_image',
  AudioPage = 'page_audio',
  Article = 'app_article',
  Flashcards = 'flashcard_deck',
  Flashcard = 'flashcard',
  Audio = 'audio',
  RelatedContentPage = 'page_related_content',
  Lottie = 'lottie_json',
  PdfBook = 'pdf_book',
  TeacherArticle = 'app_article_teacher',
  ArticleContent = 'app_article_content',
  ArticleTabs = 'app_article_tabs',
  Colophon = 'product_colophon',
  Featured = 'app_featured',
  Subject = 'app_subject',
  SubjectHeader = 'app_subject_header',
  ModelText = 'model_text',
  Chatbot = 'chatbot',
  TermExam = 'app_term_exam',
  Scene = 'scene',
  SceneObject = 'scene_object',
  Prompt = 'prompt',
  FormWriter = 'form_writer',
  Form = 'form',
}
